import React from 'react'

const CircularProgress = ({
  progress = 0, // valor de 0 a 100
  status = 'uploading',
  size = 24,
  strokeWidth = 4
}) => {
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const strokeDasharray = circumference
  const strokeDashoffset = circumference - (progress / 100) * circumference

  return (
    <div className="flex items-center justify-center" style={{ width: size, height: size }}>
      {status === 'uploading' && (
        <svg width={size} height={size} className="-rotate-90 transform">
          <circle
            stroke="#e5e7eb" // cinza claro (bg)
            fill="transparent"
            strokeWidth={strokeWidth}
            r={radius}
            cx={size / 2}
            cy={size / 2}
          />
          <circle
            stroke="#2563eb" // azul (barra de progresso)
            fill="transparent"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
            r={radius}
            cx={size / 2}
            cy={size / 2}
            className="transition-all duration-300 ease-in-out"
          />
        </svg>
      )}

      {status === 'success' && (
        <div className="flex h-full w-full items-center justify-center rounded-full bg-green-600">
          <svg className="h-1/2 w-1/2 text-white" viewBox="0 0 24 24" fill="currentColor">
            <path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z" />
          </svg>
        </div>
      )}

      {status === 'error' && (
        <div className="flex h-full w-full items-center justify-center rounded-full bg-red-600">
          <svg className="h-1/2 w-1/2 text-white" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
          </svg>
        </div>
      )}
    </div>
  )
}

export default CircularProgress
